import React from 'react'
import useMatomo from '@/integrations/tracking/matomo/useMatomo'
import posthog from '@/integrations/tracking/posthog/PostHogClient'
import { PostHogProvider } from 'posthog-js/react'
import AppTrackingProviderInner from '@/integrations/tracking/AppTrackingProvider/AppTrackingProviderInner'
import { FeatureFlagsProvider } from '@/app/providers/FeatureFlagProvider'

interface Props {
  children: React.ReactNode
}

const AppTrackingProvider = ({ children }: Props) => {
  useMatomo()

  return (
    <PostHogProvider client={posthog}>
      <FeatureFlagsProvider>
        <AppTrackingProviderInner>{children}</AppTrackingProviderInner>
      </FeatureFlagsProvider>
    </PostHogProvider>
  )
}

export default AppTrackingProvider
